import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Welcome Section */}
      <section className="section">
        <h1>Cottage Fire</h1>
        <p>Handmade sweets, jams, and baked goods — made with care in our cottage kitchen.</p>
      </section>

      {/* Product Section */}
      <section className="section" id="products">
        <h2>Our Products</h2>
        <ul className="product-list">
          <li><strong>5-Pepper Jelly</strong> – $6</li>
          <li><strong>Candy Pecans</strong> – $6<br />
            <em>Flavors: Cinnamon Sugar, Maple Brown Sugar</em>
          </li>
          <li><strong>Classic Cupcakes</strong> – $24/dozen<br />
            <em>Vanilla, Chocolate, Red Velvet with choice of buttercream icing</em>
          </li>
          <li><strong>Premium Cupcakes</strong> – $30/dozen<br />
            <em>Lemon Blueberry, Cookies & Cream, Key Lime with choice of buttercream or cream cheese icing</em>
          </li>
          <li><strong>Sheet Cakes</strong><br />
            <em>Ask about 1/2 or full sheet cakes</em>
          </li>
        </ul>
      </section>

      {/* Contact Section */}
      <section className="section" id="contact">
        <h2>Contact Us</h2>
        <form action="https://formspree.io/f/xvgqagew" method="POST">
          <input type="text" name="name" placeholder="Your Name" required />
          <br />
          <input type="email" name="email" placeholder="Your Email" required />
          <br />
          <textarea name="message" placeholder="Your Message" rows="4" required></textarea>
          <br />
          <button type="submit">Send Message</button>
        </form>
      </section>
    </div>
  );
}

export default App;